import React from 'react';
import { get, isNull } from 'lodash';
import { IBANInfoIcon } from './IBANInfoIcon';

const ValidIBANBIC = ({ type, value }) =>
  isNull(value) ? (
    ''
  ) : (
    <dl>
      <dt>{type}</dt>
      <dd>{value}</dd>
    </dl>
  );

export const IBANAndBICDisplay = ({ account, content }) => {
  const iban = get(account, 'accountDetails.iban');
  const bic = get(account, 'accountDetails.bic');

  return iban || bic ? (
    <div className="account-summary__more__balances cardsticky__hide">
      <div className="account-summary__more__balances__iban">
        <h5 className="account-summary__more__previousinfo cardsticky__hide">
          IBAN and BIC
        </h5>
        <IBANInfoIcon content={content} scope={this} />
      </div>
      <div className="account-summary__more__balances__details">
        <ValidIBANBIC type="IBAN" value={iban} />
        <ValidIBANBIC type="BIC" value={bic} />
      </div>
    </div>
  ) : null;
};
